import { render } from "./discord.svg?vue&type=template&id=d4e57560"
const script = {}
script.render = render

export default script